import { useQuery } from '@tanstack/react-query';
import { getSensitivityLogs } from '@src/api/aiAlerts';
import { trackQueryError } from '@src/utils/sensor/apptracker';
import { invertProductMap } from '../HeaderPanel/SensitivityLogs/utils';

export const useFetchSensitivityLogs = () => {
  return useQuery(
    ['ai-alert-sensitivity-log'],
    () => {
      return getSensitivityLogs().then(({ data }) =>
        (data || []).map((log) => ({ ...log, context: invertProductMap[log.app] || log.app })),
      );
    },
    {
      retry: 3,
      refetchOnWindowFocus: false,
      staleTime: Infinity,
      cacheTime: Infinity,
      onError: (err) => {
        trackQueryError({ type: 'ai-alert-sensitivity-log-error', err });
      },
    },
  );
};
